import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { WebsiteText } from '../../components/WebsiteText'
import { getIntegrationsCategories } from './data/categories'

export const IntegrationMetadata = ({
  websiteUrl,
  categories,
  className,
}: {
  className?: string
  websiteUrl: string
  categories: string[]
}) => {
  const intl = useIntl()
  const categoryLabels = getIntegrationsCategories(intl)

  return (
    <div className={className}>
      <div className="margin-bottom-24">
        <WebsiteText
          variant="smallUppercase"
          className="shade-20 margin-bottom-8"
        >
          <FormattedMessage
            id="integration.page.aboutSectionTitle"
            defaultMessage="Built by"
          />
        </WebsiteText>
        <WebsiteText variant="body" className="font-weight-semibold">
          <FormattedMessage
            id="integration.page.builtBy"
            defaultMessage="Slite"
          />
        </WebsiteText>
      </div>
      <div className="margin-bottom-32">
        <WebsiteText
          variant="smallUppercase"
          className="shade-20 margin-bottom-8"
        >
          <FormattedMessage
            id="integration.page.resources"
            defaultMessage="Resources"
          />
        </WebsiteText>
        <WebsiteText variant="body">
          <a
            className="shade-05 shade-20-on-hover font-weight-semibold"
            href={websiteUrl}
          >
            {websiteUrl}
          </a>
        </WebsiteText>
      </div>

      <div className="margin-bottom-12">
        <WebsiteText
          variant="smallUppercase"
          className="shade-20 margin-bottom-8"
        >
          <FormattedMessage
            id="integration.page.categories"
            defaultMessage="Categories"
          />
        </WebsiteText>
        {categories.map((category) => (
          <WebsiteText
            variant="body"
            key={category}
            className="margin-bottom-4 font-weight-semibold"
          >
            {categoryLabels[category as keyof typeof categoryLabels]}
          </WebsiteText>
        ))}
      </div>
    </div>
  )
}
